import { FiFileText } from "react-icons/fi";
import type { CoreDataModel, PreschoolModel } from "@/models";
import {
  formatFieldName,
  formatFieldValue,
} from "../hooks/useDiscrepancyPopup";

type RecordDataTableProps = {
  referenceRecord: Record<string, unknown>;
  affectedFields: string[];
  recordTypeName: string;
  coreData: CoreDataModel;
  preschools: PreschoolModel[];
  leaName: string;
};

const HIDDEN_FIELDS = new Set([
  "RecordId",
  "KeyHash",
  "DataHash",
  "OperationKeyHash",
  "Id",
  "FileSubmissionId",
  "RecordTypeCode",
  "TransactionTypeCode",
  "LangRecords",
  "SLngRecords",
  "FamilyRecords",
  "Enrollments",
  "ClassroomAssignments",
  "StaffAssignments",
]);

export function RecordDataTable({
  referenceRecord,
  affectedFields,
  recordTypeName,
  coreData,
  preschools,
  leaName,
}: RecordDataTableProps) {
  const visibleEntries = Object.entries(referenceRecord).filter(
    ([key]) => !HIDDEN_FIELDS.has(key)
  );
  return (
    <div className="record-data-table">
      <div className="record-data-table__header">
        <div className="d-flex align-items-center gap-2">
          <FiFileText size={16} />
          <span>{recordTypeName} Record</span>
        </div>
      </div>
      <table className="table mb-0 record-data-table__table">
        <thead className="visually-hidden">
          <tr>
            <th scope="col">Field Name</th>
            <th scope="col">Field Value</th>
          </tr>
        </thead>
        <tbody>
          {visibleEntries.length === 0 ? (
            <tr>
              <td colSpan={2} className="record-data-table__empty">
                No fields to display
              </td>
            </tr>
          ) : (
            visibleEntries.map(([key, value]) => {
              const isAffectedField = affectedFields.some(
                (f) => f.toLowerCase() === key.toLowerCase()
              );
              return (
                <tr key={key}>
                  <td
                    className={`record-data-table__key${isAffectedField ? " record-data-table__key--affected" : ""}`}
                  >
                    {formatFieldName(key)}
                  </td>
                  <td
                    className={`record-data-table__value${isAffectedField ? " record-data-table__value--affected" : ""}`}
                  >
                    {formatFieldValue(
                      value,
                      key,
                      coreData,
                      preschools,
                      leaName
                    )}
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
}
